import { Section, type SectionProps } from '../Section';

export type RootProps = SectionProps;

export function Root(props: RootProps) {
  return <Section {...props} />;
}
